import OperationFormPage from "./OperationFormPage";

const IncidentFormPage = () => <OperationFormPage resource="incidents" />;

export default IncidentFormPage;
